import { createActionGroup, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IServerSideGetRowsRequest } from 'ag-grid-community/dist/types/src/interfaces/iServerSideDatasource';
import { AgentActions } from '../../../../../../graphql';

export const AGENT_ACTIONS_API_ACTIONS = createActionGroup({
  source: 'Agent Actions SSR API',
  events: {
    get: props<{ request: IServerSideGetRowsRequest }>(),
    success: props<{ rows: AgentActions[]; totalCount: number }>(),
    error: props<{ error: HttpErrorResponse }>(),
  },
});

export const AGENT_ACTIONS_ACTIONS = createActionGroup({
  source: 'Agent Actions Report',
  events: {
    setActiveView: props<{ viewName: string | null }>(),
  },
});
